<template>
	<div
		class="wrapper"
		:class="[
			{ 'nav-open': $sidebar.showSidebar },
			{ noSidebar: !hasSidebar },
			{ rtl: $route.meta.rtlActive }
		]"
	>
		<template v-if="hasSidebar">
			<DashSideNav v-if="isLoggedIn"/>
			<SignUpNavBar v-else/>
		</template>

		<div class="main-panel box_bg_color">
			<TopNavbar/>
			<div class="content" @click="toggleSidebar">
				<zoom-center-transition :duration="200" mode="out-in">
					<!-- your content here -->
					<router-view></router-view>
				</zoom-center-transition>
			</div>
			<ContentFooter/>
		</div>
	</div>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import TopNavbar from "./TopNavbar.vue";
import SignUpNavBar from "src/views/Layout/SignUpNavBar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashSideNav from "./DashSideNav.vue";

import {ZoomCenterTransition} from "vue2-transitions";

import "perfect-scrollbar/css/perfect-scrollbar.css";
import {mapGetters} from "vuex";

function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) {
		new PerfectScrollbar(`.${className}`);
	} else {
		// try to init it later in case this component is loaded async
		setTimeout(() => {
			initScrollbar(className);
		}, 100);
	}
}

export default {
	components: {
		SignUpNavBar,
		TopNavbar,
		ContentFooter,
		ZoomCenterTransition,
		DashSideNav
	},
	methods: {
		toggleSidebar() {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.displaySidebar(false);
			}
		},
	},
	mounted() {
		let docClasses = document.body.classList;
		let isWindows = navigator.platform.startsWith("Win");
		if (isWindows) {
			initScrollbar("sidebar");
			initScrollbar("sidebar-wrapper");
			initScrollbar("main-panel");

			docClasses.add("perfect-scrollbar-on");
		} else {
			docClasses.add("perfect-scrollbar-off");
		}
	},
	computed: {
		...mapGetters({isLoggedIn: "isLoggedIn"}),
		meta() {
			let { meta } = this.$route;
			return meta;
		},
		hasSidebar() {
			return this.meta.sidebar !== 'none';
		},
	},
	watch: {
		$route() {
			const container = this.$el.querySelector(".main-panel");
			container.scrollTo(0, 0);
		},
	}
};
</script>

<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
	from {
		opacity: 0;
		transform: scale3d($scaleSize, $scaleSize, $scaleSize);
	}
	to {
		opacity: 1;
	}
}

.main-panel .zoomIn {
	animation-name: zoomIn95;
}

@keyframes zoomOut95 {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
		transform: scale3d($scaleSize, $scaleSize, $scaleSize);
	}
}

.main-panel .zoomOut {
	animation-name: zoomOut95;
}

.nobar {
	width: 100% !important;
}
</style>
